import ca_global from '@/_helpers/lang/validators/ca_global'
import es_global from '@/_helpers/lang/validators/es_global'
import en_global from '@/_helpers/lang/validators/en_global'
import es from '@/_helpers/lang/validators/es'
import ca from '@/_helpers/lang/validators/ca'
import en from '@/_helpers/lang/validators/en'

let langValidate = {
    es: {
        messages: es_global,
        fields: es
    },
    ca: {
        messages: ca_global,
        fields: ca
    },
    en: {
        messages: en_global,
        fields: en
    }
};

export {
  langValidate
}